var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import cx from 'classnames';
import { observer } from 'mobx-react';
import styles from './pane.module.scss';
import FAIcon from '../icons/FAIcon';
const stopPropagation = (e) => {
    // tslint:disable-next-line:no-console
    console.log('DOUBLE CLICK', e.target);
    e.stopPropagation();
};
export function PaneAction({ onClick, title, className }) {
    return (React.createElement(FAIcon, { className: cx(styles.action, className), onClick: onClick, onDoubleClick: stopPropagation, title: title }));
}
let Pane = class Pane extends React.Component {
    constructor() {
        super(...arguments);
        this.toggleSize = () => this.props.store.toggleSize(this.props.panel);
    }
    render() {
        const { title, subTitle, actions = [], panel, className, children } = this.props;
        if (!title && actions.length > 0) {
            throw new Error(`Pane component "${panel}" has no "title" but has "actions". Actions can't be accessed!`);
        }
        return (React.createElement("div", { className: cx(styles.root, className) },
            title && (React.createElement("div", { className: styles.header, onDoubleClick: this.toggleSize },
                React.createElement("div", { className: styles.titleContainer },
                    React.createElement("h2", { className: styles.title }, title),
                    subTitle && React.createElement("span", { className: cx('badge', styles.subTitle) }, subTitle)),
                React.createElement("div", { className: styles.actions },
                    actions.map((a, i) => React.createElement(PaneAction, Object.assign({ key: i }, a))),
                    React.createElement(PaneAction, { title: "Toggle Pane", className: cx('fas', 'fa-window-maximize'), onClick: this.toggleSize })))),
            children));
    }
};
Pane = __decorate([
    observer
], Pane);
export default Pane;
